import React from 'react';
import { PropTypes } from 'prop-types';
import { Modal } from '@custom-components';
import { flowRight as compose } from 'lodash';
import { Content } from './styles';
import withAuth from '../../../hocs/withAuth';

class ConfirmModal extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    selectedValues: PropTypes.shape({
      propertyName: PropTypes.shape({ query: PropTypes.string, value: PropTypes.string }),
      supplierName: PropTypes.shape({ query: PropTypes.string, value: PropTypes.string })
    }).isRequired,
    handleConfirm: PropTypes.func.isRequired,
    openModal: PropTypes.bool.isRequired
  };

  render() {
    const { closeModal, selectedValues, handleConfirm, openModal } = this.props;
    return (
      <Content>
        <Modal
          openModal={openModal}
          smallModal
          title="Supplier change confirmation"
          content={`You are about to change property ${selectedValues.propertyName.query}'s supplier
                to  ${selectedValues.supplierName.query}. Are you sure you want to proceed with this change?`}
          actions={[
            {
              label: 'Cancel',
              onClick: () => {
                closeModal();
              },
              btnTheme: 'secondary'
            },
            {
              label: 'Confirm',
              onClick: () => {
                handleConfirm(selectedValues);
              },
              btnTheme: 'primary'
            }
          ]}
          handleClose={() => {
            closeModal();
          }}
        />
      </Content>
    );
  }
}
export default compose(withAuth())(ConfirmModal);
